<style scoped>
@import '../../components/Styling/common.scss';
</style>
<template>
  <div class="container">
    <center class="mt-5"><h2>Thank you, your form has been submitted.</h2></center>
    <center class="mt-5"><h4>You can safely close this page.</h4></center>
    <center v-if="!submitted" class="mt-5">
      <label for="rating-inline">Please rate your experience:</label>
      <b-form-rating
        variant="info"
        v-model="rating"
        no-border
        id="rating-inline"
        inline
      ></b-form-rating>
      <!--div class="mt-2" v-if="rating"><h5>{{rating === 5? 'Great 🔥 Please tell us what you liked or what new features would be super useful.': 
                rating === 4? 'How can we get that 5th star??':
                rating === 3? 'We\'d love to get suggestions on how to improve.':
                'Oh no 😥 what went wrong?? tell us here or using the help button bottom right of your screen.'}}
               </h5> </div-->
      <div v-if="rating" class="mt-4">
        <b-form-textarea
          id="textarea"
          @keypress.enter.prevent
          v-model="comment"
          :placeholder="
            rating === 5
              ? 'Great 🔥 Please tell us what you liked or what new features would be super useful.'
              : rating === 4
              ? 'How can we get that 5th star??'
              : rating === 3
              ? 'We\'d love to get suggestions on how to improve.'
              : 'Oh no 😥 what went wrong?? please tell us how we can improve.'
          "
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </div>
      <div v-if="rating" class="mt-4">
        <b-button @click="submitRating" class="center" variant="info">Send feedback</b-button>
      </div>
    </center>
    <center id="thankyou" class="my-5" v-if="submitted">Thank you!</center>
    <div v-if="!($route.query.email && this.$route.query.email === 'anon@insdi.com')">
      <center class="mt-5"><h5>Want to access your forms again in the future?</h5></center>
      <center v-if="this.$route.params.tenant !== 'loadsure-eu'">
        Bookmark <a href="https://home.insdi.com" target="_blank">home.insdi.com</a> to login and
        view all your in progress or submitted forms
      </center>
      <center><b-button class="mt-3" size="sm" @click="gotoHome()">View my Forms</b-button></center>
    </div>
    <center v-if="this.$route.params.tenant !== 'loadsure-eu'">
      <img
        class="mt-5"
        style="height: 60px; width: auto"
        src="../../assets/images/insdi.png"
        alt="Responsive image"
      />
    </center>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'submitted',
  methods: {
    async submitRating() {
      const url =
        'https://f.insdi.com/' +
        this.$route.params.tenant +
        '/formshare/' +
        this.$route.query.token +
        '/rating'
      const post_body = {
        rating: this.rating.toString(),
        comments: this.comment
      }
      await axios({
        method: 'post',
        url: url,
        headers: {
          'Content-Type': 'application/json',
          Authorization: this.$route.query.auth,
          'X-Insdi-Api-Key': '1'
        },
        data: JSON.stringify(post_body)
      })
        .then(response => {
          console.log('Response:' + response)
          this.submitted = true
        })
        .catch(error => {
          console.log(error)
        })
      // location.href = "https://www.insdi.com"
    },
    gotoHome() {
      let url =
        'https://home.insdi.com/#/shares?v=1&token=' +
        this.$route.query.token +
        '&auth=' +
        this.$route.query.auth +
        '&showforms=true&user=' +
        this.$route.query.user
      if (this.$route.query.email) {
        url = url + '&email=' + this.$route.query.email
      } else if (this.$route.query.phone) {
        url = url + '&phone=' + encodeURIComponent(this.$route.query.phone)
      }
      //   console.log(url)
      window.location.href = url
      //  alert(url)
    }
  },
  data() {
    return {
      comment: '',
      rating: 0,
      submitted: false
    }
  }
}
</script>
